module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/general_error_modal.975bb622.svg";